import { render, staticRenderFns } from "./gatewayTable.vue?vue&type=template&id=2e7c3ff4&scoped=true"
import script from "./gatewayTable.vue?vue&type=script&lang=js"
export * from "./gatewayTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7c3ff4",
  null
  
)

export default component.exports